export default function TemporaryPersonCreateButton({ name, eventName, canCreate, onCreate }) {
    const trimmed = name?.trim();
    const disabled = !trimmed || !canCreate;
    const hint = !trimmed ? 'Escriu un nom al cercador. ' : !canCreate ? 'Selecciona una caixa a la pinya. ' : '';

    return <button type="button" className="casteller-search-create" disabled={disabled}
        aria-label={trimmed ? `Afegir «${trimmed}» com a temporal` : 'Afegir temporal'}
        title={`${hint}Només per a ${eventName || 'aquest esdeveniment'}. Sense compte d’accés.`}
        onClick={() => { if (!disabled) onCreate(trimmed); }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true" focusable="false">
            <path d="M12 5v14M5 12h14" />
        </svg>
        <span>Nou</span>
    </button>;
}
